import { defineRoutes } from "@/service/routing/schema";

const base = "/uslugi/ubezpieczenie";

export const insuranceRoutes = defineRoutes({
  "service.insurance.index": `${base}`,
  "service.insurance.oc": `${base}/oc`,
  "service.insurance.request": ({ id }) => `${base}/oc/wniosek/${id}`,
  "service.insurance.oc.ergo_hestia": `${base}/oc/ergo-hestia`,
  "service.insurance.income_loss": `${base}/utrata-dochodu`,
  "service.insurance.income_loss.leadenhall": `${base}/utrata-dochodu/leadenhall`,
} as const);
